
import {AUTH_BASEURL,USER_PRODUCT_BASEURL,USER_ADMIN_BASEURL,USER_USER_BASEURL,TENANT_API_BASEURL} from './env.js';

export const LOGIN_URL = AUTH_BASEURL + "/tenant/login";
export const FIRSTPASSWORD_URL = AUTH_BASEURL + "/tenant/firstTimeChangePassword";

export const CHANGEPASSWORD_URL = AUTH_BASEURL + "/tenant/changePassword";

export const USERLIST_URLS = {
  product: USER_PRODUCT_BASEURL + "/tenant/listUsers",
  admin: USER_ADMIN_BASEURL + "/admin/listUsers",
  user: USER_USER_BASEURL + "/user/listUsers"
}

export const USRCREATE_URLS = {
  product: USER_PRODUCT_BASEURL + "/tenant/createUser",
  admin: USER_ADMIN_BASEURL + "/admin/createUser",
  user: USER_USER_BASEURL + "/user/createUser"
}

export const USERDELETE_URLS = {
  product: USER_PRODUCT_BASEURL + "/tenant/deleteUser",
  admin: USER_ADMIN_BASEURL + "/admin/deleteUser",
  user: USER_USER_BASEURL + "/user/deleteUser"
}

export const USERSTATUS_URLS = {
  product: USER_PRODUCT_BASEURL + "/tenant/statusControl",
  admin: USER_ADMIN_BASEURL + "/admin/statusControl",
  user: USER_USER_BASEURL + "/user/statusControl"
}

export const USERUPDATE_URLS = {
  product: USER_PRODUCT_BASEURL + "/tenant/updateUserAttributes",
  admin: USER_ADMIN_BASEURL + "/admin/updateUserAttributes",
  user: USER_USER_BASEURL + "/user/updateUserAttributes"
}

export const USERPREST_URLS = {
  product: USER_PRODUCT_BASEURL + "/tenant/resetPassword",
  admin: USER_ADMIN_BASEURL + "/admin/resetPassword",
  user: USER_USER_BASEURL + "/user/resetPassword"
}

export const TENANTLIST_URL = TENANT_API_BASEURL + "/tenant/search";
export const TENANTCREATE_URL = TENANT_API_BASEURL + "/tenant/register";
export const TENANTUPDATE_URL = TENANT_API_BASEURL + "/tenant/update";
export const TENANTDELETE_URL = TENANT_API_BASEURL + "/tenant/delete";